import {SearchModelBase} from './SearchModelBase';
import { ListFilterType } from '../../fms.core/constants';

export class AmsListItemBase extends SearchModelBase {
    listType: ListFilterType = 0;
}
